// src/components/NotificationBell.jsx
import React, { useState } from "react";
import axios from "axios";
import { getFcmToken } from "../firebaseMessaging";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:9001";

function NotificationBell() {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleEnable = async () => {
    setLoading(true);
    try {
      // 1. Get FCM token
      const token = await getFcmToken();
      if (!token) {
        alert("Could not get notification token");
        setLoading(false);
        return;
      }

      // 2. Simple browser id (or reuse your existing one)
      const browserId =
        localStorage.getItem("yoga_browser_id") ||
        `yoga-${Math.random().toString(36).slice(2)}-${Date.now()}`;
      localStorage.setItem("yoga_browser_id", browserId);

      // 3. Send to backend: /api/notifications/user/subscribe
      await axios.post(`${API_BASE_URL}/api/notifications/user/subscribe`, {
        browser_id: browserId,
        token,
      });

      setEnabled(true);
      alert("Notifications enabled!");
    } catch (err) {
      console.error("Enable notifications failed:", err);
      alert("Failed to enable notifications");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleEnable}
      disabled={loading}
      style={{
        border: "none",
        background: "transparent",
        cursor: loading ? "default" : "pointer",
      }}
      title={enabled ? "Notifications enabled" : "Enable notifications"}
    >
      {loading ? "..." : enabled ? "🔔" : "🔕"}
    </button>
  );
}

export default NotificationBell;
